import { useEffect, useState } from 'react'
import { fetchSurnameData } from '../../services/SurnameAPI/fetchSurnameData'

export const useSurname = (surname) => {
  const [surnameData, setSurnameData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const normalizedSurname = surname?.toLowerCase()

  useEffect(() => {
    // Don't fetch if no surname provided
    if (!normalizedSurname?.length) {
      setSurnameData(null)
      setError(null)
      return
    }

    let isMounted = true

    const fetchData = async () => {
      setLoading(true)
      setError(null)

      try {
        const data = await fetchSurnameData(normalizedSurname)

        if (!isMounted) return

        setSurnameData(data)
      } catch (err) {
        if (isMounted) {
          console.error('Error fetching surname:', err)
          setError(err)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchData()

    // Cleanup function
    // eslint-disable-next-line consistent-return
    return () => {
      isMounted = false
    }
  }, [normalizedSurname, surname])

  return { surnameData, loading, error }
}
